module.exports = __webpack_public_path__ + "static/media/RB_MonoRed_RGB.252a447d.svg";